import Model from "@/models/Model"

export default class AActivate extends Model {
    resource() {
        return "activate"
    }
}